import { loginHelper } from "@utils/LoginHelper";
import { useCallback } from "react";
import swal from "sweetalert2";
import useNotification from "./useNotification";
import { createDB } from "@src/db/EpisodesDb";
import Cookies from "js-cookie";

const useApiError = () => {
  const flashNotification = useNotification();

  const setNetworkErrorAlertWithReloadButton = useCallback(
    (e: any) => {
      if (e.message === "No internet connection") {
        if (Number(Cookies.get("UIDT"))) {
          createDB(`DB_${Cookies.get("UIDT")}`);
        }
        return;
      }
      if (e?.code && e.code === "ERR_CANCELED") return;
      if (e?.code && e.code === "ERR_NETWORK") {
        swal
          .fire({
            icon: "error",
            text: "THERE WAS A NETWORK ERROR. PLEASE CHECK YOUR NETWORK CONNECTION OR TRY RELOADING THE PAGE.",
            showCloseButton: true,
            buttonsStyling: true,
            showConfirmButton: true,
            confirmButtonText: "Reload page!",
            scrollbarPadding: false
          })
          .then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
      } else if (e.response && e.response.status === 401) {
          loginHelper();
      } else if (e.response && e.response.status === 404) {
        flashNotification({ status: false, message: "Resource(s) not found." });
      } else if (e.response && e.response.status === 500) {
        flashNotification(e.response.data);
      } else {
        flashNotification({
          status: false,
          message:
            e?.response?.data?.message ??
            e?.message ??
            "Something went wrong. Please reload the page.",
        });
      }
    },
    [flashNotification]
  );

  return setNetworkErrorAlertWithReloadButton;
};

export default useApiError;
